import { render } from "./grading-reporting.vue?vue&type=template&id=0f4a086b&scoped=true"
import script from "./grading-reporting.vue?vue&type=script&lang=js"
export * from "./grading-reporting.vue?vue&type=script&lang=js"

import "./grading-reporting.vue?vue&type=style&index=0&id=0f4a086b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4a086b"]])

export default __exports__